import { createAction } from 'redux-actions';
import { actionKey } from './constants';
import { PapiDeviation } from '@wix/da-papi-types';

export const initializeBackgrounds = createAction(
  `${actionKey}.INIT`,
  () => ({})
);

export const saveBackground = createAction(
  `${actionKey}.SAVE_BACKGROUND`,
  (deviation: PapiDeviation, backgroundId: number) => ({
    deviation,
    backgroundId,
  })
);
export const saveBackgroundSuccess = createAction(
  `${actionKey}.SAVE_BACKGROUND.SUCCESS`,
  (deviationId: number, backgroundId: number) => ({
    deviationId,
    backgroundId,
  })
);
export const saveBackgroundFail = createAction(
  `${actionKey}.SAVE_BACKGROUND.FAIL`,
  (deviationId: number, backgroundId: number) => ({
    deviationId,
    backgroundId,
  })
);
export const setBackground = createAction(
  `${actionKey}.SET_BACKGROUND`,
  (deviationId: number, backgroundId: number) => ({
    deviationId,
    backgroundId,
  })
);

export const showBackgroundPicker = createAction(
  `${actionKey}.SHOW_BG_PICKER`,
  (deviation: PapiDeviation) => ({ deviation })
);
export const fetchBackgrounds = createAction(
  `${actionKey}.FETCH_BACKGROUNDS`,
  () => ({})
);
export const previewBackground = createAction(
  `${actionKey}.PREVIEW_BACKGROUND`,
  (backgroundId: number | undefined) => ({
    backgroundId,
  })
);
